"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoConfigurationError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "NoConfigurationFile";
const messageKey = "plugins.spfx.error.noConfiguration";
class NoConfigurationError extends teamsfx_api_1.UserError {
    constructor() {
        super({
            source: constants_1.Constants.ActionName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey),
        });
    }
}
exports.NoConfigurationError = NoConfigurationError;
//# sourceMappingURL=noConfigurationError.js.map